import api from './api'

/**
 * Serviço de Estrutura Organizacional
 */
export default {
  // Departamentos
  departments: {
    list(params = {}) {
      return api.get('/api/departments', { params })
    },
    
    create(departmentData) {
      return api.post('/api/departments', departmentData)
    },

    update(id, departmentData) {
      return api.put(`/api/departments/${id}`, departmentData)
    },

    getManagers(tenantId = null) {
      const params = tenantId ? { tenantId } : {}
      return api.get('/api/departments/managers', { params })
    },
  },

  // Cargos
  jobRoles: {
    list(params = {}) {
      return api.get('/api/job-roles', { params })
    },

    create(jobRoleData) {
      return api.post('/api/job-roles', jobRoleData)
    },
    
    update(id, jobRoleData) {
      return api.put(`/api/job-roles/${id}`, jobRoleData)
    },
    
    delete(id) {
      return api.delete(`/api/job-roles/${id}`)
    },
    
    getByDepartment(departmentId) {
      return api.get(`/api/job-roles/by-department/${departmentId}`)
    },
  },

  // Usuários por Departamento
  users: {
    getByDepartment(departmentId) {
      return api.get(`/api/users/by-department/${departmentId}`)
    },
  },
}
